import { arrayMove } from 'react-sortable-hoc'
import config from '../../config'

function onDrop(imgState: any, newImgs: any, maxImages: number = config.MAX_IMAGES): any {
  if (!imgState || !newImgs || !maxImages) return []

  let newState = [...imgState, ...newImgs.slice(0, maxImages - imgState.length)]
  newState = newState.slice(Math.max(newState.length - maxImages, 0))
  return newState
}

function onSortEnd(imgState, oldIndex, newIndex) {
  return arrayMove(imgState, oldIndex, newIndex)
}

function onRemoveImageV2(imgState, index) {
  window.URL.revokeObjectURL(imgState[index].preview)
  return imgState.map((img, i) => ({ ...img, removed: i === index }))
}

async function preloadImage(url) {
  return new Promise<void>((resolve, reject) => {
    try {
      const img = new Image()
      img.src = url
      img.onload = () => {
        resolve()
      }
    } catch (error) {
      reject(error)
    }
  })
}

function b64toBlob(b64Data, contentType = '', sliceSize = 512) {
  const byteCharacters = atob(b64Data)
  const byteArrays = []

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize)

    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i += 1) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers)
    byteArrays.push(byteArray)
  }

  const blob = new Blob(byteArrays, { type: contentType })
  return blob
}

function blobToFile(theBlob, fileName) {
  const imageBlob = theBlob
  imageBlob.lastModifiedDate = new Date()
  imageBlob.name = fileName
  imageBlob.preview = ''
  return imageBlob
}

const hackRotationFn = value => {
  // if the image comes in from the URL as transformed,
  // the image will come in rotated, but will also say how much its rotated
  // so if you'll end up rotating an image twice, or un rotate
  // setting rotation to -Math.abs because we do hackrotation - rotation and if its 0, it'll be negative.
  // Then we need negative abs because thumbor rotates in an opposite way than css rotation

  // there is a slight probability that if the signed key == rotate(XX) that this will break but Ill take my chances
  let hackRotation = 0
  try {
    hackRotation = parseInt(value.match(/rotate\(\d+\)/)[0].match(/\d+/)[0])
  } catch (error) {
    //
  }

  return hackRotation
}

export default {
  onDrop,
  onSortEnd,
  onRemoveImageV2,
  preloadImage,
  b64toBlob,
  blobToFile,
  hackRotationFn
}
